/**
 * @generated SignedSource<<276ab9fb796c48525737e72f97fc5221>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutCreditCardListWrapper_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutAddCreditCard_viewer" | "CheckoutCreditCardList_viewer">;
  readonly " $fragmentType": "CheckoutCreditCardListWrapper_viewer";
};
export type CheckoutCreditCardListWrapper_viewer$key = {
  readonly " $data"?: CheckoutCreditCardListWrapper_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutCreditCardListWrapper_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutCreditCardListWrapper_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutCreditCardList_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutAddCreditCard_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "8e35546adec1c78b107ff6c725b8cea7";

export default node;
